<nz-row class="guide-icons" [nzGutter]="[5, 5]">
  <ng-container *ngFor="let icon of guideIcons">
    <nz-col
      [nzXXl]="4"
      [nzXl]="6"
      [nzLg]="6"
      [nzMd]="6"
      [nzSm]="6"
      [nzXs]="12"
    >
      <app-lot-icon [icon]="icon" [enabled]="true" [clickable]="false"></app-lot-icon>
    </nz-col>
  </ng-container>
</nz-row>
